<script>
    export let text; text;
    export let raw; raw;
</script>
<slot />
